export const theme = {
  palette: {
    themePrimary: '#262262',
    themeDarkAlt: '#262262',
    themeSecondary: '#FFFFFF',
    alert: '#dc1c2e',
  },
  fonts: {
    tiny: { fontSize: '10px' },
    xSmall: { fontSize: '11px' },
    small: { fontSize: '12px' },
    smallPlus: { fontSize: '14px' },
    medium: { fontSize: '16px' },
    mediumPlus: { fontSize: '18px' },
    large: { fontSize: '20px' },
    xLarge: { fontSize: '22px' },
    // xxLarge:        { fontSize: '28px' },
    // superLarge:     { fontSize: '42px' },
    // mega:           { fontSize: '64px' },
  },
  logo_url:
    'https://res.cloudinary.com/auctiontech/image/upload/v1631026259/dav/assets/propnow.png',
  favicon_url:
    'https://res.cloudinary.com/auctiontech/image/upload/v1699285967/dav/assets/propnow-favicon.png',
};



// WEBPACK FOOTER //
// ./src/app/@propnow/theme.js